import * as actionTypes from "./actionTypes";
import vediAPI from "../../utils/vedi-api/vediAPI";
import moment from "moment";

export const setComunicaciones = (comunicaciones) => ({
  type: actionTypes.SET_COMUNICACIONES,
  comunicaciones,
});

export const setComunicacionesFailed = (error) => ({
  type: actionTypes.SET_COMUNICACIONES_FAILED,
  error,
});

export const getCommunications = async () => {
  const FechaDesde = moment().subtract(4, "months").format("MM/DD/YYYY");
  const FechaHasta = moment().format("MM/DD/YYYY");

  const { data } = await vediAPI.get(
    `/v1/Comunicaciones?FechaDesde=${FechaDesde}&FechaHasta=${FechaHasta}`
  );

  if (!data.ok) throw new Error(data.error);

  return data.return;
};

export const updateComunicaciones = (Ids) => ({
  type: actionTypes.UPDATE_COMUNICACIONES,
  Ids,
});

export const updateComunicacionesFailed = (error) => ({
  type: actionTypes.UPDATE_COMUNICACIONES_FAILED,
  error,
});


export const setCurrentCommunication = (communication) => ({
  type: actionTypes.SET_CURRENT_COMMUNICATION,
  communication,
});
